import { render, staticRenderFns } from "./InterviewFeedBack.vue?vue&type=template&id=234ef146&scoped=true"
import script from "./InterviewFeedBack.vue?vue&type=script&lang=js"
export * from "./InterviewFeedBack.vue?vue&type=script&lang=js"
import style0 from "./InterviewFeedBack.vue?vue&type=style&index=0&id=234ef146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ef146",
  null
  
)

export default component.exports